var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { RequestClient } from '../basics/request-client.service';
import { autoinject } from 'aurelia-framework';
import { Api } from '../../constants/modules/api.constants';
import * as Enumerable from 'linq';
import { CloneUtility } from '../../utilities/clone';
import { TokenClient } from '../authentication/token-client.service';
import { ConfigClientService } from './client-config.service';
import { Md5 } from '../../utilities/md5';
import { LotteryTags } from '../../models/modules/lotteryplatform-client.models';
import { toNative, toNativeVoid } from '../../utilities/promise-utils';
var BrandClientService = /** @class */ (function () {
    function BrandClientService(requestClient, tokenClient, configClientService) {
        this.requestClient = requestClient;
        this.tokenClient = tokenClient;
        this.configClientService = configClientService;
        this.currentModels = [];
        this.models = [];
    }
    BrandClientService.prototype.getBrandOrOperatorStats = function (brandId, operatorId, showAll) {
        return toNative(this.requestClient.get(Api.ManageBrands.getStats, { brandId: brandId, operatorId: operatorId, showAll: showAll }));
    };
    BrandClientService.prototype.getBrand = function (request) {
        return toNative(this.requestClient.get(Api.ManageBrands.Get, request));
    };
    BrandClientService.prototype.getTemplates = function () {
        return toNative(this.requestClient.get(Api.ManageBrands.GetTemplates, {}));
    };
    BrandClientService.prototype.getLotteryWidgets = function () {
        return toNative(this.requestClient.get(Api.ManageBrands.GetLotteryWidgets, {}));
    };
    BrandClientService.prototype.getBrandCurrencies = function (request) {
        return toNative(this.requestClient.get(Api.ManageBrands.GetBrandCurrencies, request));
    };
    BrandClientService.prototype.getCustomBrands = function (currentTemplate) {
        return toNative(this.requestClient.get(Api.ManageBrands.GetCustomBrands + "?templateName=" + currentTemplate, {}));
    };
    BrandClientService.prototype.checkUsingCustomBrands = function (currentTemplate, brandName) {
        return toNative(this.requestClient.get(Api.ManageBrands.CheckUsingCustomBrands + "?templateName=" + currentTemplate + "&brandName=" + brandName, {}));
    };
    BrandClientService.prototype.delete = function (request) {
        return toNative(this.requestClient.post(Api.ManageBrands.Delete, {}, request));
    };
    BrandClientService.prototype.recordAffiliateLink = function (item) {
        return toNative(this.requestClient.post(Api.AffiliateLinkAnalytic.Record, {}, item));
    };
    BrandClientService.prototype.removeTheme = function (id) {
        return toNative(this.requestClient.post(Api.ManageBrands.DeleteBrandTheme + "/" + id, {}, {}));
    };
    BrandClientService.prototype.save = function (request) {
        return toNative(this.requestClient.post(Api.ManageBrands.Save, {}, request));
    };
    BrandClientService.prototype.saveTemplates = function (request) {
        return toNative(this.requestClient.postFormData(Api.ManageBrands.SaveTemplates, request));
    };
    BrandClientService.prototype.saveLotteryWidgets = function (request) {
        return toNative(this.requestClient.postFormData(Api.ManageBrands.SaveLotteryWidgets, request));
    };
    BrandClientService.prototype.AreMarginValuesValid = function (request) {
        return toNative(this.requestClient.postFormData(Api.ManageBrands.AreMarginValuesValid, request));
    };
    // changed return type from `any` -> `Promise<boolean>` to match the post<T> below
    BrandClientService.prototype.manageBrandLotterySubscriptions = function (brandId, operatorId, configs) {
        return toNative(this.requestClient.post(Api.ManageBrands.ManageBrandLotterySubscriptions, {}, {
            brandId: brandId,
            operatorId: operatorId,
            lotterySubscriptions: configs
        }));
    };
    BrandClientService.prototype.getLotteryBrandSubsciptions = function (brandId, operatorId) {
        return toNative(this.requestClient.post(Api.ManageBrands.GetLotteryBrandSubsciptions, {}, { brandId: brandId, operatorId: operatorId }));
    };
    BrandClientService.prototype.manageOperatorLotteriesForPricing = function (operatorId, lotteryIds) {
        return this.requestClient.post(Api.ManageBrands.ManageOperatorLotteriesForPricing, {}, {
            operatorId: operatorId,
            lotteryIds: lotteryIds
        });
    };
    BrandClientService.prototype.diff = function (obj1, obj2) {
        var e_1, _a;
        if (Array.isArray(obj2)) {
            if (obj1 == null || obj1 == undefined)
                return obj2;
            var newObj = null;
            try {
                for (var obj2_1 = __values(obj2), obj2_1_1 = obj2_1.next(); !obj2_1_1.done; obj2_1_1 = obj2_1.next()) {
                    var item = obj2_1_1.value;
                    var key = item.key;
                    var obj = obj1.filter(function (x) { return x.key == key; })[0];
                    var difference = this.diff(obj, item);
                    if (difference != null) {
                        if (!newObj)
                            newObj = [];
                        difference.key = key;
                        newObj.push(difference);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (obj2_1_1 && !obj2_1_1.done && (_a = obj2_1.return)) _a.call(obj2_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return newObj;
        }
        else if (Object.prototype.toString.call(obj2).toLowerCase() == "[object object]") {
            var newObj = null;
            if (obj1 == null || obj1 == undefined)
                return obj2;
            for (var x in obj2) {
                var difference = this.diff(obj1[x], obj2[x]);
                if (difference != null) {
                    if (!newObj)
                        newObj = {};
                    newObj[x] = difference;
                }
            }
            return newObj;
        }
        else {
            if (obj1 == obj2)
                return null;
            return obj2;
        }
    };
    BrandClientService.prototype.saveBranding = function (filesToSave, saveNewTheme, templateInternalName, themeInternalName, isPreview, isWidget, brandId) {
        var e_2, _a;
        var _this = this;
        var configModel = Enumerable.from(this.models).firstOrDefault(function (x) { return x.key == TemplateType.Config; });
        var request = {
            isWidget: isWidget,
            saveNewTheme: saveNewTheme,
            templateInternalName: templateInternalName,
            themeName: saveNewTheme && !isPreview && themeInternalName == 'preview' ? 'active-theme' : themeInternalName,
            brandId: brandId,
            isPreview: isPreview,
            models: Enumerable.from(this.models)
                .where(function (x) { return saveNewTheme || filesToSave.indexOf(x.key) != -1; })
                .select(function (x) {
                var _a, _b, _c, _d;
                if (!x.defaultModel) // if not from brand
                    return x;
                var shouldInherit = (_d = (_c = (_b = (_a = configModel === null || configModel === void 0 ? void 0 : configModel.model) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.template) === null || _c === void 0 ? void 0 : _c.inheritChangesFromBaseTemplate) !== null && _d !== void 0 ? _d : true;
                var diff = shouldInherit ? _this.diff(x.defaultModel, x.model) : x.model;
                // return changes only
                var result = {
                    defaultModel: null,
                    key: x.key,
                    path: x.path,
                    md5Hash: x.md5Hash,
                    model: diff ? diff : {}
                };
                return result;
            }).toArray()
        };
        if (isPreview) { // if not preview set current model to model
            this.currentModels = [];
            try {
                for (var _b = __values(this.models), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    var model = JSON.stringify(item.model);
                    var defaultModel = item.defaultModel ? JSON.stringify(item.defaultModel) : null;
                    this.currentModels.push({
                        path: item.path,
                        key: item.key,
                        md5Hash: item.md5Hash,
                        model: model,
                        defaultModel: defaultModel
                    });
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        return new Promise((function (resolve, reject) {
            toNative(_this.requestClient.post(Api.ManageBrands.SaveBranding, {}, request)).then(function (response) {
                var e_3, _a;
                _this.configClientService.invalidateCache(_this.models.map(function (x) { return x.path; }));
                try {
                    for (var _b = __values(request.models), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var model = _c.value;
                        var item = Enumerable.from(_this.models).firstOrDefault(function (x) { return x.md5Hash == model.md5Hash; });
                        if (item) {
                            item.md5Hash = Md5.hashStr(JSON.stringify(model.model)).toString();
                        }
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                resolve(response);
            }, reject);
        }));
    };
    BrandClientService.prototype.initBrandingModel = function (template, themeName, brand, isManagingDefaultConfig, isWidget) {
        return __awaiter(this, void 0, void 0, function () {
            var templates, folders, _loop_1, this_1, name, path, existingDefaultFolder, model, folders_1, folders_1_1, folder, e_4_1, folders, _loop_2, this_2, theme, defaultPath, defaultThemePath, path, existingBrandFolder, model, folders_2, folders_2_1, folder, e_5_1, _loop_3, this_3, existing, _a, _b, item;
            var e_4, _c, e_5, _d, e_6, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        templates = isWidget ? "widgets" : "templates";
                        if (!isManagingDefaultConfig) return [3 /*break*/, 9];
                        folders = isWidget ? TemplateHelper.getWidgets() : TemplateHelper.getTemplates();
                        _loop_1 = function (folder) {
                            var e_7;
                            return __generator(this, function (_g) {
                                switch (_g.label) {
                                    case 0:
                                        _g.trys.push([0, 2, , 3]);
                                        name = (themeName ? themeName : "preview");
                                        path = "app/styles/client/".concat(templates, "/").concat(template.toLowerCase(), "/config/").concat(name, "/").concat(folder, ".json");
                                        existingDefaultFolder = Enumerable.from(this_1.models).firstOrDefault(function (x) { return x.key == folder; });
                                        if (!existingDefaultFolder) {
                                            existingDefaultFolder = {
                                                key: folder
                                            };
                                            this_1.models.push(existingDefaultFolder);
                                        }
                                        return [4 /*yield*/, this_1.configClientService.requireJSONAndMd5Hash(path, null, null, false)];
                                    case 1:
                                        model = _g.sent();
                                        existingDefaultFolder.path = path;
                                        existingDefaultFolder.model = model.model;
                                        existingDefaultFolder.md5Hash = model.md5Hash;
                                        existingDefaultFolder.defaultModel = null;
                                        return [3 /*break*/, 3];
                                    case 2:
                                        e_7 = _g.sent();
                                        throw brand + " theme " + themeName + " template " + template + " config " + folder;
                                    case 3: return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 6, 7, 8]);
                        folders_1 = __values(folders), folders_1_1 = folders_1.next();
                        _f.label = 2;
                    case 2:
                        if (!!folders_1_1.done) return [3 /*break*/, 5];
                        folder = folders_1_1.value;
                        return [5 /*yield**/, _loop_1(folder)];
                    case 3:
                        _f.sent();
                        _f.label = 4;
                    case 4:
                        folders_1_1 = folders_1.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_4_1 = _f.sent();
                        e_4 = { error: e_4_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (folders_1_1 && !folders_1_1.done && (_c = folders_1.return)) _c.call(folders_1);
                        }
                        finally { if (e_4) throw e_4.error; }
                        return [7 /*endfinally*/];
                    case 8: return [3 /*break*/, 17];
                    case 9:
                        folders = isWidget ? TemplateHelper.getWidgets() : TemplateHelper.getTemplates();
                        _loop_2 = function (folder) {
                            var _h, _j;
                            return __generator(this, function (_k) {
                                switch (_k.label) {
                                    case 0:
                                        theme = themeName ? themeName : "preview";
                                        defaultPath = "app/styles/client/".concat(templates, "/").concat(template.toLowerCase(), "/config/active-theme/").concat(folder, ".json");
                                        defaultThemePath = "app/styles/client/brandings/".concat(brand.toLowerCase(), "/config/active-theme-").concat(template.toLowerCase(), "/").concat(folder, ".json");
                                        path = "app/styles/client/brandings/".concat(brand.toLowerCase(), "/config/").concat(theme, "-").concat(template.toLowerCase(), "/").concat(folder, ".json");
                                        existingBrandFolder = Enumerable.from(this_2.models).firstOrDefault(function (x) { return x.key == folder; });
                                        if (!existingBrandFolder) {
                                            existingBrandFolder = {
                                                key: folder
                                            };
                                            this_2.models.push(existingBrandFolder);
                                        }
                                        return [4 /*yield*/, this_2.configClientService.requireJSONAndMd5Hash(path, defaultThemePath, defaultPath, false)];
                                    case 1:
                                        model = _k.sent();
                                        if (!!model.model) return [3 /*break*/, 3];
                                        return [4 /*yield*/, this_2.configClientService.requireJSONAndMd5Hash(path, null, null, false)];
                                    case 2:
                                        model = _k.sent();
                                        _k.label = 3;
                                    case 3:
                                        existingBrandFolder.path = path;
                                        existingBrandFolder.model = model.model;
                                        existingBrandFolder.md5Hash = model.md5Hash;
                                        _h = existingBrandFolder;
                                        if (!model) return [3 /*break*/, 5];
                                        return [4 /*yield*/, this_2.configClientService.requireJSON(defaultPath, null, null, false)];
                                    case 4:
                                        _j = _k.sent();
                                        return [3 /*break*/, 6];
                                    case 5:
                                        _j = null;
                                        _k.label = 6;
                                    case 6:
                                        _h.defaultModel = _j;
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_2 = this;
                        _f.label = 10;
                    case 10:
                        _f.trys.push([10, 15, 16, 17]);
                        folders_2 = __values(folders), folders_2_1 = folders_2.next();
                        _f.label = 11;
                    case 11:
                        if (!!folders_2_1.done) return [3 /*break*/, 14];
                        folder = folders_2_1.value;
                        return [5 /*yield**/, _loop_2(folder)];
                    case 12:
                        _f.sent();
                        _f.label = 13;
                    case 13:
                        folders_2_1 = folders_2.next();
                        return [3 /*break*/, 11];
                    case 14: return [3 /*break*/, 17];
                    case 15:
                        e_5_1 = _f.sent();
                        e_5 = { error: e_5_1 };
                        return [3 /*break*/, 17];
                    case 16:
                        try {
                            if (folders_2_1 && !folders_2_1.done && (_d = folders_2.return)) _d.call(folders_2);
                        }
                        finally { if (e_5) throw e_5.error; }
                        return [7 /*endfinally*/];
                    case 17:
                        _loop_3 = function (item) {
                            var model_1 = JSON.stringify(item.model);
                            var defaultModel = item.defaultModel ? JSON.stringify(item.defaultModel) : null;
                            existing = Enumerable.from(this_3.currentModels).firstOrDefault(function (x) { return x.key == item.key; });
                            if (!existing) {
                                existing = {
                                    key: item.key
                                };
                                this_3.currentModels.push(existing);
                            }
                            existing.md5Hash = item.md5Hash;
                            existing.path = item.path;
                            existing.model = model_1;
                            existing.defaultModel = defaultModel;
                        };
                        this_3 = this;
                        try {
                            for (_a = __values(this.models), _b = _a.next(); !_b.done; _b = _a.next()) {
                                item = _b.value;
                                _loop_3(item);
                            }
                        }
                        catch (e_6_1) { e_6 = { error: e_6_1 }; }
                        finally {
                            try {
                                if (_b && !_b.done && (_e = _a.return)) _e.call(_a);
                            }
                            finally { if (e_6) throw e_6.error; }
                        }
                        //this.currentModels = JSON.stringify (this.model);
                        return [2 /*return*/, this.models];
                }
            });
        });
    };
    BrandClientService.prototype.getBranding = function (isManagingDefaultConfig, isWidget, templateName, themeName, brand, templateType, brandingType, key, isAds) {
        if (key === void 0) { key = null; }
        if (isAds === void 0) { isAds = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.models || this.models.length == 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.initBrandingModel(templateName, themeName, brand, isManagingDefaultConfig, isWidget)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.getBrandingInternal(this.models, templateName, templateType, brandingType, isWidget, key, isAds)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BrandClientService.prototype.getDefaultBranding = function (isWidget, templateName, themeName, templateType, brandingType, key, isAds) {
        if (key === void 0) { key = null; }
        if (isAds === void 0) { isAds = false; }
        return __awaiter(this, void 0, void 0, function () {
            var models, templates, folders, folders_3, folders_3_1, item, path, model, e_8_1;
            var e_8, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        models = [];
                        templates = isWidget ? "widgets" : "templates";
                        folders = isWidget ? TemplateHelper.getWidgets() : TemplateHelper.getTemplates();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, 7, 8]);
                        folders_3 = __values(folders), folders_3_1 = folders_3.next();
                        _b.label = 2;
                    case 2:
                        if (!!folders_3_1.done) return [3 /*break*/, 5];
                        item = folders_3_1.value;
                        path = "app/styles/client/".concat(templates, "/").concat(templateName, "/config/active-theme/").concat(item, ".json");
                        return [4 /*yield*/, this.configClientService.requireJSONAndMd5Hash(path, null, null, false)];
                    case 3:
                        model = _b.sent();
                        models.push({
                            path: path,
                            key: item,
                            model: model.model,
                            md5Hash: model.md5Hash,
                            defaultModel: null
                        });
                        _b.label = 4;
                    case 4:
                        folders_3_1 = folders_3.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_8_1 = _b.sent();
                        e_8 = { error: e_8_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (folders_3_1 && !folders_3_1.done && (_a = folders_3.return)) _a.call(folders_3);
                        }
                        finally { if (e_8) throw e_8.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/, this.getBrandingInternal(models, templateName, templateType, brandingType, isWidget, key, isAds)];
                }
            });
        });
    };
    BrandClientService.prototype.getBrandingInternal = function (models, templateName, templateType, brandingType, isWidget, key, isAds) {
        if (key === void 0) { key = null; }
        if (isAds === void 0) { isAds = false; }
        return __awaiter(this, void 0, void 0, function () {
            var modelsEnumerable, jsonFileModel, data, formattedKey_1, templates, defaultModel, result, defaultData, resultDefault, resultDefault, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        modelsEnumerable = Enumerable.from(models);
                        jsonFileModel = modelsEnumerable.firstOrDefault(function (x) { return x.key == templateType; });
                        data = isAds ? jsonFileModel.model[TemplateType.Ads] : jsonFileModel.model[templateType];
                        if (!key) return [3 /*break*/, 2];
                        formattedKey_1 = LotteryKeyHelper.getKey(key);
                        templates = isWidget ? "widgets" : "templates";
                        return [4 /*yield*/, this.configClientService.requireJSON('app/styles/client/' + templates + '/' + templateName + '/config/active-theme/' + templateType + '.json', null, null, false)];
                    case 1:
                        defaultModel = _b.sent();
                        result = Enumerable.from(data).firstOrDefault(function (x) { return x.key == formattedKey_1; });
                        if (result)
                            return [2 /*return*/, brandingType ? result[brandingType] : result];
                        defaultData = isAds ? defaultModel[TemplateType.Ads] : defaultModel[templateType];
                        result = Enumerable.from(defaultData).firstOrDefault(function (x) { return x.key == formattedKey_1; });
                        if (!result) {
                            result = Enumerable.from(defaultData).firstOrDefault(function (x) { return x.key == 'default'; });
                            resultDefault = CloneUtility.clone(result);
                            resultDefault.key = formattedKey_1;
                            data.push(resultDefault);
                            return [2 /*return*/, brandingType ? resultDefault[brandingType] : resultDefault];
                        }
                        else {
                            resultDefault = CloneUtility.clone(result);
                            data.push(resultDefault);
                            return [2 /*return*/, brandingType ? resultDefault[brandingType] : resultDefault];
                        }
                        _b.label = 2;
                    case 2: return [2 /*return*/, brandingType ? data[brandingType] : data];
                    case 3:
                        _a = _b.sent();
                        console.log('Cannot find brand config! ' + templateName + '  >> ' + templateType + '   >>' + key);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BrandClientService.prototype.manageBrandInstantGameSubscriptions = function (brandId, operatorId, configs) {
        return this.requestClient.post(Api.ManageBrands.ManageBrandInstantGameSubscriptions, {}, {
            brandId: brandId,
            operatorId: operatorId,
            instantGameSubscriptions: configs
        });
    };
    BrandClientService.prototype.getInstantGameBrandSubsciptions = function (brandId, operatorId) {
        return toNative(this.requestClient.post(Api.ManageBrands.GetInstantGameBrandSubsciptions, {}, {
            brandId: brandId,
            operatorId: operatorId,
        }));
    };
    BrandClientService.prototype.getSweepstakeBrandSubsciptions = function (brandId, operatorId) {
        return toNative(this.requestClient.post(Api.ManageBrands.GetSweepstakeBrandSubsciptions, {}, {
            brandId: brandId,
            operatorId: operatorId,
        }));
    };
    BrandClientService.prototype.manageBrandSweepstakeSubscriptions = function (brandId, operatorId, configs) {
        return this.requestClient.post(Api.ManageBrands.ManageBrandSweepstakeSubscriptions, {}, {
            brandId: brandId,
            operatorId: operatorId,
            sweepstakeSubscriptions: configs
        });
    };
    BrandClientService.prototype.topup = function (brandId, topUpAmount) {
        return toNativeVoid(this.requestClient.post("".concat(Api.ManageBrands.Topup, "/").concat(brandId), {}, {
            amount: topUpAmount
        }));
    };
    BrandClientService.prototype.getInsuranceAccounts = function () {
        return toNative(this.requestClient.get(Api.ManageBrands.GetInsuranceAccounts));
    };
    BrandClientService.prototype.getBrandInsuranceAccountId = function (brandId) {
        return toNative(this.requestClient.get("".concat(Api.ManageBrands.GetBrandInsuranceAccountId, "/").concat(brandId)));
    };
    BrandClientService.prototype.setInsuranceAccount = function (brandId, insuranceAccountId) {
        return toNativeVoid(this.requestClient.post("".concat(Api.ManageBrands.SetInsuranceAccount, "/").concat(brandId), {}, { insuranceAccountId: insuranceAccountId }));
    };
    BrandClientService.prototype.validateBrandLotteryMarginCost = function (brandId) {
        return toNative(this.requestClient.get("".concat(Api.ManageBrands.ValidateBrandLotteriesMarginCost, "/").concat(brandId), {}));
    };
    BrandClientService = __decorate([
        autoinject(),
        __metadata("design:paramtypes", [RequestClient, TokenClient, ConfigClientService])
    ], BrandClientService);
    return BrandClientService;
}());
export { BrandClientService };
var LotteryKeyHelper = /** @class */ (function () {
    function LotteryKeyHelper() {
    }
    LotteryKeyHelper.getKey = function (key) {
        if (key)
            return key.toLowerCase()
                .replace(/ /g, '-')
                .replace(/\//g, '-')
                .replace(/\\/g, '-');
        return key;
    };
    return LotteryKeyHelper;
}());
export { LotteryKeyHelper };
var BundleKeyHelper = /** @class */ (function () {
    function BundleKeyHelper() {
    }
    BundleKeyHelper.getKey = function (key) {
        if (key)
            return key.toLowerCase()
                .replace(/ /g, '-')
                .replace(/\//g, '-')
                .replace(/\\/g, '-');
        return key;
    };
    BundleKeyHelper.getBundleByKey = function (bundles, key) {
        var _this = this;
        var lotteriesEnumerable = Enumerable.from(bundles);
        if (key == LotteryTags.HighestJackpot) {
            var topLottery = lotteriesEnumerable.orderByDescending(function (lottery) { return lottery.totalJackpot; }).firstOrDefault();
            return topLottery;
        }
        else if (key == LotteryTags.SecondHighestJackpot) {
            var topLottery = lotteriesEnumerable.orderByDescending(function (lottery) { return lottery.totalJackpot; }).skip(1).firstOrDefault();
            return topLottery;
        }
        else if (key == LotteryTags.ThirdHighestJackpot) {
            var topLottery = lotteriesEnumerable.orderByDescending(function (lottery) { return lottery.totalJackpot; }).skip(2).firstOrDefault();
            return topLottery;
        }
        else {
            var lotteryByName = lotteriesEnumerable.firstOrDefault(function (x) { return _this.getKey(x.name) == key; });
            return lotteryByName;
        }
    };
    return BundleKeyHelper;
}());
export { BundleKeyHelper };
var SyndicateKeyHelper = /** @class */ (function () {
    function SyndicateKeyHelper() {
    }
    SyndicateKeyHelper.getKey = function (key) {
        if (key)
            return key.toLowerCase()
                .replace(/ /g, '-')
                .replace(/\//g, '-')
                .replace(/\\/g, '-');
        return key;
    };
    return SyndicateKeyHelper;
}());
export { SyndicateKeyHelper };
var InstantGameKeyHelper = /** @class */ (function () {
    function InstantGameKeyHelper() {
    }
    InstantGameKeyHelper.getKey = function (key) {
        if (key)
            return key.toLowerCase()
                .replace(/ /g, '-')
                .replace(/\//g, '-')
                .replace(/\\/g, '-');
        return key;
    };
    return InstantGameKeyHelper;
}());
export { InstantGameKeyHelper };
var TemplateHelper = /** @class */ (function () {
    function TemplateHelper() {
    }
    TemplateHelper.getTemplates = function () {
        return [
            TemplateType.Overlay,
            TemplateType.Cart,
            TemplateType.Lobby,
            TemplateType.Results,
            TemplateType.InstantGame,
            TemplateType.Lottery,
            TemplateType.Bundle,
            TemplateType.Syndicate,
            TemplateType.Assets,
            TemplateType.Purchases,
            TemplateType.Config
        ];
    };
    TemplateHelper.getWidgets = function () {
        return [
            TemplateType.Assets
        ];
    };
    return TemplateHelper;
}());
export { TemplateHelper };
var BrandingType = /** @class */ (function () {
    function BrandingType() {
    }
    BrandingType.Text = 'text';
    BrandingType.Colors = 'color';
    BrandingType.Images = 'image';
    BrandingType.Featured = 'featured';
    BrandingType.HotLotteries = 'hot-lotteries';
    BrandingType.CarouselLotteries = 'carousel-lotteries';
    BrandingType.QuickPlay = 'quick-play';
    BrandingType.CarouselScratchcards = 'carousel-scratchcards';
    BrandingType.InstantGameCards = 'instant-game-cards';
    return BrandingType;
}());
export { BrandingType };
var TemplateType = /** @class */ (function () {
    function TemplateType() {
    }
    TemplateType.Overlay = 'overlay';
    TemplateType.Ticket = 'ticket';
    TemplateType.Template = 'template';
    TemplateType.Cart = 'cart';
    TemplateType.Lobby = 'lobby';
    TemplateType.Config = 'config';
    TemplateType.Results = 'results';
    TemplateType.Ads = 'ads';
    TemplateType.Lottery = 'lotteries';
    TemplateType.InstantGame = 'instant-games';
    TemplateType.Bundle = 'bundles';
    TemplateType.Syndicate = 'syndicates';
    TemplateType.Assets = 'assets';
    TemplateType.Purchases = 'purchases';
    TemplateType.ExternalTermsAndConditions = 'external-terms-and-conditions';
    return TemplateType;
}());
export { TemplateType };
